import * as api from 'api/vendors';

export const fetchVendor = id => ({
  type: 'FETCH_VENDOR',
  payload: api.fetchVendor(id),
});

export const fetchAllVendorsManagement = params => ({
  type: 'FETCH_VENDORS_MANAGEMENT',
  payload: api.fetchAllVendorsManagement(params),
});

export const fetchAllVendorsTobeMerged = params => ({
  type: 'FETCH_VENDORS_TO_BE_MERGED',
  payload: api.fetchAllVendorsManagement(params),
});

export const fetchManagementFilters = params => ({
  type: 'FETCH_MANAGEMENT_FILTERS',
  payload: api.fetchAllVendorsManagement(params),
});

export const setVendor = vendor => ({
  type: 'SET_VENDOR',
  payload: vendor,
});
